import { render, staticRenderFns } from "./TheChat.vue?vue&type=template&id=630d7212&scoped=true&"
import script from "./TheChat.vue?vue&type=script&lang=js&"
export * from "./TheChat.vue?vue&type=script&lang=js&"
import style0 from "./TheChat.vue?vue&type=style&index=0&id=630d7212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d7212",
  null
  
)

export default component.exports